<!--
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-17 11:18:28
 * @LastEditTime: 2020-09-25 18:00:53
 * @Description: File description
-->
<template>
  <div class="discount">
    <img src="../assets/images/bg-discount.png" alt />
    <img class="discount-reward" src="../assets/images/reward-register.png" alt />
    <div class="discount-btn">
      <div class="discount-btn-detail" @click="goTouch">
        <img src="../assets/images/discount-invite.png" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      youngUser: '20036',
      discountList: [1, 1]
    }
  },
  created () {
    // 判断是否为幼小老带新
    this.youngUser = this.$route.query.s === '20036'
  },
  methods: {
    goTouch (e) {
      this.$xesLogger.clickMsg({
        elem: e.target,
        params: { action: 'goTouch', clickid: '5.4.1' }
      })
      window.location.replace('https://xueersi.com/d?entry=header')
    }
  }
}
</script>
<style lang="less" scoped>
.discount {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #f93644;

  &-reward {
    position: absolute;
    top: 220px;
  }

  &-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 64px;
    padding: 10px 25px;
    background-color: #fff;
  }
}
</style>
